/**
 * MonitoringCenter Component
 *
 * Main dashboard card containing tabs for alerts, products, and history.
 * Handles search, filters, tab content, and actions menu orchestration.
 *
 * REFACTORED: Uses MonitoringCenterContext instead of 88+ props.
 * @see app/contexts/MonitoringCenterContext.tsx
 *
 * Sub-components extracted to:
 * @see app/components/dashboard/monitoring-center/
 */

import React from 'react';
import { Card, BlockStack } from '@shopify/polaris';

import { useMonitoringShared } from '../../contexts/MonitoringCenterContext';

// Import sub-components from the monitoring-center directory
import {
  MonitoringHeader,
  FilterPillsSection,
  TabNavigation,
  TabContent,
} from './monitoring-center';

// Re-export types for consumers
export type { TabDescriptor } from '../../contexts/MonitoringCenterContext';

// =============================================================================
// Main Component
// =============================================================================

/**
 * Main monitoring center component
 * Consumes MonitoringCenterContext to access all state
 */
export function MonitoringCenter() {
  const shared = useMonitoringShared();

  return (
    <div
      className="monitoring-center-card"
      style={{ animationDelay: '100ms' }}
      ref={shared.scrollRef as React.RefObject<HTMLDivElement>}
    >
      <Card>
        <BlockStack gap="400">
          <MonitoringHeader />
          <FilterPillsSection />
          <TabNavigation />
          <TabContent />
        </BlockStack>
      </Card>
    </div>
  );
}

// =============================================================================
// Legacy Props Interface (for backward compatibility during migration)
// =============================================================================

/**
 * @deprecated Use MonitoringCenterProvider context instead
 * This interface is kept for reference during migration
 */
export interface MonitoringCenterProps {
  // This interface is now empty - all props come from context
  // See MonitoringCenterProviderProps for the provider interface
}
